import React from "react";
import { Facebook } from "lucide-react";
import { BAND } from "@/data/band";

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const LINKS = [
  { label: "About", id: "about" },
  { label: "Band", id: "band" },
  { label: "2025", id: "tour" },
  { label: "Gallery", id: "gallery" },
  { label: "Listen", id: "listen" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-[#0a0a0b] border-t border-white/10">
      <div className="marquee-mask overflow-hidden border-b border-white/10 py-5">
        <div className="marquee-track">
          {Array.from({ length: 2 }).map((_, k) => (
            <span key={k} className="flex items-center">
              {["Catch them if you can", "Live in Scotland", "Rock · Alternative · Pop · Dance", "2025 Tour Incoming"].map((t) => (
                <span key={t} className="font-display text-3xl md:text-4xl text-white/20 mx-8">
                  {t} <span className="text-[var(--sb-red)]">✷</span>
                </span>
              ))}
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="max-w-sm">
            <button onClick={() => go("home")} className="font-display text-4xl text-white">
              SONG<span className="text-[var(--sb-red)]">BIRD</span>
            </button>
            <p className="text-white/55 mt-4">{BAND.tagline}</p>
            <a
              href={BAND.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="mt-5 inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors"
            >
              <Facebook size={18} /> Follow on Facebook
            </a>
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-4">Explore</div>
            <div className="grid grid-cols-2 gap-x-10 gap-y-3">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => go(l.id)}
                  data-testid={`footer-${l.id}`}
                  className="text-left text-white/70 hover:text-[var(--sb-red)] transition-colors font-semibold uppercase tracking-wider text-sm"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-white/40 text-sm">
          <span>© {new Date().getFullYear()} Songbird. All rights reserved.</span>
          <span>Made for the love of live music.</span>
        </div>
      </div>
    </footer>
  );
}
